import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';
import { resolveApiBase } from './apiHost';

const root = ReactDOM.createRoot(document.getElementById('root'));
const render = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

/*
 * Settle which bridge this contest uses BEFORE the first render.
 *
 * The Lumen -> Laravel cutover runs per contest, and this app cannot tell which
 * side it is on without asking (see apiHost.js). Waiting here keeps a session
 * on ONE host: registering against one bridge and then calling the other would
 * carry a member the second may not know.
 *
 * It never blocks for long. The lookup is cached per contest, carries its own
 * 2s timeout, and every failure resolves to the bridge every contest already
 * uses — so the worst case is today's behaviour, a moment later.
 */
resolveApiBase(config.CONTEST_API_URL).finally(render);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
